export const DashboardConfig = ($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('app.dashboard', {
      url: '^/dashboard',
      template: '<dashboard></dashboard>'
    });
};


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/dashboard/dashboard.config.js
 **/